import type {ChangeGroupGenerationUnavailableReasons} from '../types/group-types'

export function getChangeGroupGenerationUnavailableMessage(
  reason: ChangeGroupGenerationUnavailableReasons | undefined,
) {
  switch (reason) {
    case 'DIFF_TOO_LARGE':
    case 'TOO_MANY_GROUPS':
      return 'Groups are unavailable because the PR exceeds the size limit.'
    case 'DIFF_TOO_SMALL':
    case 'TOO_FEW_GROUPS':
      return 'Grouping was skipped because all changes are closely related.'
    case 'UNABLE_TO_GENERATE':
    default:
      return 'Copilot was unable to generate groups for this pull request.'
  }
}
